import { R as i } from "../result-BPlAbaTC.js";
async function n(r) {
  return new Promise(
    (e) => setTimeout(() => {
      r(), e();
    })
  );
}
class o extends Error {
  constructor() {
    super("unreachable code");
  }
}
function s(r) {
  throw new o();
}
const c = (...r) => {
}, t = async (...r) => {
};
export {
  i as Result,
  o as UnreachableError,
  n as defer,
  c as noop,
  t as noopAsync,
  s as unreachable
};
//# sourceMappingURL=index.js.map
